import { Company } from "generated/graphql";

export const getSecondaryContacts = (company: Company) =>
  company.contacts.filter((contact) => contact.primary === false);
